<template>
  <transition>
    <section
      class="board-left"
      @dragover="outputDragDropFile($event, 'over')"
      @dragleave="outputDragDropFile($event, 'leave')"
      @drop="outputDragDropFile($event, 'drop')"
    >
      <h2 class="hide">의사결정 레이어</h2>
      <!-- @click="$event.target.parentElement.classList.toggle('active')" -->
      <button
        id="leftBtnToggle"
        type="button"
        class="left-btn_toggle"
        :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' "
        v-show="paperInfo.permission > 0"
        @click="leftBtnToggle"
      ></button>
      <div class="left_wrap">
        <div class="info">
          <div class="data">
            <div class="data_tit ell-singleline">
              {{
                topInfo.folderInfo == null
                  ? ""
                  : topInfo.folderInfo.categoryName
              }}
            </div>
            <div class="data_tit_big multi-ellipsis">
              {{ topInfo.paperTitle }}
            </div>
            <UserInfo
              :userName="topInfo.regUserName"
              :userNameEn="topInfo.regUserNameEn"
              :userCount="topInfo.userListCount"
              :paperId="editorData.paperId"
              :addClassName="'white'"
              :isBottomLeft="false"
            />
          </div>
        </div>
        <!--//info-->

        <div class="decision_making">
          <div class="tit">{{ $i18nUtil.trans("entity.decision","의사결정") }}</div>
          <!-- 정보 없을시 노출 S -->
          <template v-if="this.items == null || this.items.length == 0">
            <div class="no-data" v-html="$i18nUtil.trans('message.BoardOpinion.001','내용, 이미지, 파일 등 수행한 업무 블록을 선택 후<br />의사결정을 요청해보세요.')">
            </div>
          </template>
          <!-- 정보 없을시 노출 E -->
          <!-- 정보 노출 S -->
          <div class="data" v-if="this.items != null && this.items.length > 0">
            <input type="hidden" v-model="editorData.paperId" />
            <!-- list -->
            <div
              class="grp"
              v-for="(item, index) in items"
              :key="index"
              :transfer-data="item"
            >
              <div class="top">
                <div
                  v-if="item.status == 'APROVAL'"
                  class="toggle-approval active"
                >{{ $i18nUtil.trans("entity.decision.status.approval", "승인") }}</div>
                <div
                  v-else-if="item.status == 'RETURN'"
                  class="toggle-back"
                >{{ $i18nUtil.trans("entity.decision.status.reject", "반려") }}</div>
                <div v-else-if="item.status == 'DEFER'">{{ $i18nUtil.trans("entity.decision.status.defer", "보류") }}</div>
                <div v-else class="toggle-approval">{{ $i18nUtil.trans("entity.decision.status.proceeding", "승인 전") }}</div>

                <div
                  class="droplayer icon more right nosel"
                  v-show="
                    (item.regUserId == userInfo.userId ||
                      item.userId == userInfo.userId) &&
                    item.status === 'APPL'
                  "
                  @click="
                    $event.target.parentElement.classList.toggle('active')
                  "
                >
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                    </template>
                    <div class="dropdown-list">
                      <div class="dropdown-list-item">
                        <div class="tit">
                          <button
                            type="button"
                            v-if="
                              (item.regUserId == userInfo.userId ||
                                item.userId == userInfo.userId) &&
                              item.status === 'APPL'
                            "
                            @click="deldeci(item, index)"
                          >
                            {{ $i18nUtil.trans("button.delete.decision","의사결정 삭제") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </v-menu>
                </div>
                <div class="tit multi-ellipsis" @click="openModal2(item)">
                  {{ item.contents }}
                </div>
                <div class="date_grp">
                  <div class="re">
                    {{ item.regUserName }}
                  </div>
                  <div class="de active">
                    {{ item.userName }}
                  </div>
                  <div class="date">
                    <!-- {{ timeForToday(item.regDate) }} -->
                    <momentAgo prefix="" suffix="전" :date="item.regDate" lang="kr"></momentAgo>
                    <!-- {{ $moment(item.regDate).format("YYYY.MM.DD") }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 정보 노출 E -->
        </div>
        <!--//decision_making-->

        <div
          class="output"
          :class="
            this.output != null && this.output.length > 0 ? '' : 'no-data'
          "
        >
          <div class="tit">
            {{ $i18nUtil.trans("entity.file.output","최종결과물") }}
            <div class="droplayer icon more plus right nosel">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button type="button" @click="outputUpCall()">
                        {{ $i18nUtil.trans("button.fileUpload.computer","내 컴퓨터") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button type="button" @click="outputBoard()">
                        {{ $i18nUtil.trans("title.OpinionBoardFile.001","보드 내 파일 추가") }}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
            <input
              class="hidden"
              id="OutputfileUpload"
              @change="onSubmitFormOutput()"
              type="file"
              ref="Outputuploadfile"
            />
          </div>
          <!-- 정보 없을시 노출 E -->
          <div
            class="nodata outputDropZone dropFileAction"
            v-if="this.output == null || this.output.length == 0"
            v-html="$i18nUtil.trans('message.BoardOpinion.002','업무보드의 최종 결과물을 등록하여<br />  관리해보세요.')"
          >
          </div>
          <!-- 정보 없을시 노출 E -->

          <!-- 정보 노출 S -->
          <!-- Output -->
          <div class="data dropFileAction">
            <ul
              v-if="this.output != null && this.output.length > 0"
              class="outputDropZone dropFileActionC"
            >
              <li
                v-for="(itemf, index) in output"
                :key="index + 'Output'"
                :transfer-data="itemf"
              >
                <div
                  class="ico-file-ppt bg medium"
                  v-if="
                    itemf.fileExt === 'ppt' ||
                    itemf.fileExt === 'pptx' ||
                    itemf.fileExt === 'pptm' ||
                    itemf.fileExt === 'pot' ||
                    itemf.fileExt === 'potx' ||
                    itemf.fileExt === 'potm' ||
                    itemf.fileExt === 'pps' ||
                    itemf.fileExt === 'ppsx'
                  "
                ></div>
                <div
                  class="ico-file-word bg medium"
                  v-else-if="
                    itemf.fileExt === 'doc' ||
                    itemf.fileExt === 'docx' ||
                    itemf.fileExt === 'docm' ||
                    itemf.fileExt === 'dot' ||
                    itemf.fileExt === 'dotx' ||
                    itemf.fileExt === 'dotm'
                  "
                ></div>
                <div
                  class="ico-file-xlsx bg medium"
                  v-else-if="
                    itemf.fileExt === 'xls' ||
                    itemf.fileExt === 'xlsx' ||
                    itemf.fileExt === 'xlsm' ||
                    itemf.fileExt === 'xlsb' ||
                    itemf.fileExt === 'xlt' ||
                    itemf.fileExt === 'xltm'
                  "
                ></div>
                <div
                  class="ico-file-pdf bg medium"
                  v-else-if="itemf.fileExt === 'pdf'"
                ></div>
                <div
                  class="ico-file-jpg bg medium"
                  v-else-if="
                    itemf.fileExt === 'jpg' || itemf.fileExt === 'jpeg'
                  "
                ></div>
                <div
                  class="ico-file-gif bg medium"
                  v-else-if="itemf.fileExt === 'gif'"
                ></div>
                <div
                  class="ico-file-png bg medium"
                  v-else-if="itemf.fileExt === 'png'"
                ></div>
                <div
                  class="ico-file-tif bg medium"
                  v-else-if="itemf.fileExt === 'tif'"
                ></div>
                <div
                  class="ico-file-tiff bg medium"
                  v-else-if="itemf.fileExt === 'tiff'"
                ></div>
                <div
                  class="ico-file-bmp bg medium"
                  v-else-if="itemf.fileExt === 'bmp'"
                ></div>
                <div
                  class="ico-file-zip bg medium"
                  v-else-if="itemf.fileExt === 'zip'"
                ></div>
                <div
                  class="ico-file-hwp bg medium"
                  v-else-if="itemf.fileExt === 'hwp'"
                ></div>
                <div class="ico-file-etc bg medium" v-else></div>
                <div
                  class="tit"
                  @click="
                    callFileViewer({
                      type: 'SINGLE',
                      file: Object(itemf),
                    })
                  "
                >
                  {{ itemf.fileName }}
                </div>
                <div class="droplayer icon more right nosel">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                    </template>
                    <div class="dropdown-list">
                      <div class="dropdown-list-item">
                        <div class="tit">
                          <button
                            type="button"
                            @click="confirmDeleteAttach(itemf, index)"
                          >
                            {{ $i18nUtil.trans("button.file.delete","파일 삭제") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </v-menu>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Vue from "vue";
import EventBus from "@/js/eventbus/eventBus";
import UserInfo from "@/components/cowork/common/user/UserInfo";

import MyModal from "../opinion/BoardOpinionModal.vue";
import MyModalU from "../opinion/BoardOpinionModalU.vue";
import OutputBoard from "../opinion/OutputBoard.vue";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";

/* 보드 유틸 */
import BoardUtil from "../base/BoardUtil.js";

export default {
  components: {
    UserInfo,
    UserTooltip,
  },
  props: {
    paperId: String,
    userInfo: Object,
    paperInfo: Object,
    boardMemberInfo: Object,
  },

  data() {
    return {
      show: false,
      members: [],
      userGetter: {
        groupId: "",
        page: 0,
      },
      editorData: {
        paperId: this.$props.paperId,
        contents: "",
        paperFileId: "",
        userId: "",
        fileName: "",
      },
      deciup: {
        paperId: "",
        contents: "",
        paperFileId: "",
        userId: "",
        fileName: "",
      },
      items: [],
      files: [],
      output: [],
      uploadDecision: [],
      uploadOutput: [],
      upfile: {
        groupId: null,
        paperId: this.$props.paperId,
        files: [],
      },
      data: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null,
        req: {
          groupId: null,
          paperId: null,
          files: null,
        },
      },
      uploadDecisionFile: [],
      udfform: {
        paperFileId: "",
        seq: "",
        fileId: "",
        fileName: "",
      },
      modal: false,
      message: "",
      modal2: false,
      message2: "",
      projectId: null,

      /* 상단 단계,제목,멤버 정보 */
      topInfo: {
        paperTitle: "",
        regUserName: "",
        regUserNameEn:"",
        folderInfo: {
          categoryName: "",
          categoryMid: null,
        },
        userListCount: 0,
      },
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      /* 보드유틸 */
      boardUtil: BoardUtil,
      tenantId: localStorage.getItem("tenantId"),
    };
  },
  mounted() {
    this.multiElipsis(2);
    this.editorData.paperId = this.$props.paperId;
    this.initInfo();
    this.initgroup();
  },
  created() {
    EventBus.$off("outputBoardInsert");
    EventBus.$on("outputBoardInsert", (payload) => {
      this.refresh();
    });
    EventBus.$off("deleteOutputFile");
    EventBus.$on("deleteOutputFile", (payload) => {
      this.refresh();
    });
    EventBus.$off("updatePaperCommand");
    EventBus.$on("updatePaperCommand", (payload) => {
      let obj = this;
      if (payload.command == "TITLE") {
        obj.topInfo.paperTitle = payload.paperTitle;
        obj.topInfo.regUserName = obj.$i18nUtil.getLanguage() !== 'ko' && payload.regUserNameEn != null ? payload.regUserNameEn : payload.regUserName;
        obj.topInfo.regUserNameEn = obj.$i18nUtil.getLanguage() !== 'ko' && payload.regUserNameEn != null ? payload.regUserNameEn : payload.regUserName;
      } else if (payload.command == "FOLDER") {
        obj.topInfo.folderInfo = payload.folderInfo;
      } else if (payload.command == "MEMBER") {
        obj.topInfo.userListCount = payload.userListCount;
      }
    });
  },
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("common", ["SYNC_COWORK_REST_FILE_ACTION"]),
    initInfo() {
      let obj = this;
      obj.initDecisionList();
    },
    initgroup() {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/getGroupIdAndProjectIdToPaperId";
      reqData.method = "post";
      reqData.params = {
        paperId: this.$props.paperId,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        this.projectId = response.result.projectId;
        this.upfile.groupId = response.result.groupId;
      });
    },
    initDecisionList() {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/list";
      reqData.method = "post";
      reqData.params = this.editorData;
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        // obj.items = response.result;
        obj.items = obj.setLocaleData(response.result);
        obj.initOutputList();
      });
    },
    initOutputList() {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/cofile/output/list";
      reqData.method = "post";
      reqData.params = this.editorData;
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.output = response.result;
        // obj.initPaperUserList();
      });
    },

    getDecisionList() {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/list";
      reqData.method = "post";
      reqData.params = this.editorData;
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        // obj.items = response.result;
        obj.items = obj.setLocaleData(response.result);
        obj.getOutputList();
      });
    },
    getOutputList() {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/cofile/output/list";
      reqData.method = "post";
      reqData.params = this.editorData;
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.output = response.result;
      });
    },
    onSubmitFormOutput() {
      this.upfile.files = [];
      let files = this.$refs.Outputuploadfile.files;

      if (files != null) {
        this.upfile.files.push(files[0]);
      } else {
        return;
      }

      let obj = this;
      this.data.frm = new FormData();

      obj.data.sendType = "post";
      obj.data.url = "/api/cofile/paper/uploadOutput";
      obj.data.header = {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("Authorization"),
      };
      obj.data.frm.append("file", this.upfile.files[0]);
      obj.data.frm.append("groupId", this.upfile.groupId);
      obj.data.frm.append("paperId", this.upfile.paperId);
      obj.data.frm.append("projectId", this.projectId);
      obj.data.frm.append(
        "sharepointSiteId",
        String(this.paperInfo.sharepointSiteId)
      );
      obj.data.frm.append(
        "sharepointFolderId",
        String(this.paperInfo.sharepointFolderId)
      );

      let object = obj.data;
      let url = object.url;
      let frm = object.frm;
      let header = object.header;
      let sendType = object.sendType;

      obj.$axios.post(url, frm, header).then((response) => {
        if (response.data.errorCode) {
          let errorCode = response.data.errorCode;
          if (errorCode === "COFILE_DLP_ERROR") {
            /*let errorMessage = JSON.parse(response.data.errorMessage);
            let message = errorMessage.detectedMessage;
            let modalHeight = 180;

            if (errorMessage.detectedFiles.length > 0) {
              let detectedFiles = errorMessage.detectedFiles;
              if (detectedFiles[0].data.length > 0) {
                let detectedFilesData = detectedFiles[0].data;
                for (let i = 0; i < detectedFilesData.length; i++) {
                  message += "\n";
                  message +=
                    "\n- 분 류 : " +
                    detectedFilesData[i].pattern +
                    " ( " +
                    detectedFilesData[i].count +
                    " 건 ) ";
                  message += "\n- 내 용 : " + detectedFilesData[i].content;
                  modalHeight += 60;
                }
              }
            }

            modalHeight = modalHeight + "px";
            this.showAlertDialog(message, null, {
              width: "600px",
              height: modalHeight,
            });*/

            // 2023-06-20 검출 건수 표시 및 공통 함수로 처리
            //this.showAlertDialog(this.$i18nUtil.trans("AB076"));
            this.boardUtil.makeDLPErrorMsg(this, response.data.errorMessage);
            return;
          } else if (
            response.data.errorCode === "COFILE_STORAGE_CAPACITY_EXCEEDED"
          ) {
            this.showAlertDialog(
              this.$i18nUtil.trans("AB054", { groupKbn: response.data.errorMessage })
            );
            return;
          } else if (response.data.errorCode === "COFILE_FILE_UPLOAD_DENIED") {
            this.showAlertDialog(this.$i18nUtil.trans("AB069"));
            return;
          } else if (response.data.errorCode === "COFILE_FILE_UPLOAD_CAPACITY_EXCEEDED") {
             this.showAlertDialog(this.$i18nUtil.trans("AB108",{ limitSize: response.data.errorMessage /1024 /1024 }));
            return;
          }else if (response.data.errorCode === "COFILE_FILE_UPLOAD_FAIL") {
            this.showAlertDialog(this.$i18nUtil.trans("AB070"));
            return;
          } else if (response.data.errorCode === "COFILE_FILE_UPLOAD_DENIED_FROM_EXTERNAL") {
            this.showAlertDialog(this.$i18nUtil.trans("AB100"));
            return;
          }
        }

        // 2020.12.22 / uploadOutput API 내부에서 TB_PAPER_FILE insert 처리하는 내부 API 호출하므로 주석 처리
        /*let insert = "/api/copaper/output/insert";
        let insertParam = response.data.result.fileInfo;
        this.$axios.post(insert, insertParam).then(response => {});*/

        this.refresh();
        EventBus.$emit(
          "uploadBoardOutputFile",
          response.data.result.fileInfo.fileId
        );
      });
    },
    changeFileO() {
      this.upfile.files = [];
      let files = this.$refs.Outputuploadfile.files;

      this.upfile.files.push(files[0]);
    },
    viewHidden(param) {
      var con = document.getElementById("deciup" + param);
      if (con.style.display == "none") {
        con.style.display = "block";
      } else {
        con.style.display = "none";
      }
    },

    openModal(param) {
      const modalInfo = {
        name: "BoardOpinionModal",
        obj: this.$modal,
        component: MyModal,
        width: "800px",
        height: "665px",
        title: this.$i18nUtil.trans("title.BoardOpinionModal.001","의사결정하기"),
        item: param,
      };
      this.showModal(modalInfo);
    },

    openModal2(param) {
      if (param.userId === this.userInfo.userId) {
        const modalInfo = {
          name: "BoardOpinionModalU",
          obj: this.$modal,
          component: MyModalU,
          width: "800px",
          height: "665px",
          item: param,
        };
        this.showModal(modalInfo);
      } else {
        const modalInfo = {
          obj: this.$modal,
          component: MyModal,
          width: "800px",
          height: "665px",
          item: param,
          paperInfo: this.paperInfo,
        };
        this.showModal(modalInfo);
      }
    },

    refresh() {
      this.getDecisionList();
    },
    callFileViewer(param) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/checkUploadStatus",
        method: "post",
        params: param.file,
      };

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          let uploadStatus = res.result.uploadStatus;
          if (uploadStatus == "COMPLETE") {
            // this.$router.push(
            // 	"/general/viewer/" + this.upfile.groupId + "/" + param.fileId
            // );

            let hanwha = $(location).attr("origin");
            let groupId = obj.upfile.groupId;
            if (groupId != null || groupId != "") {
              window.open(
                hanwha + "/general/viewer/" + groupId + "/" + param.file.fileId
              );
            }
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinion.003","파일 업로드 처리중입니다.");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
          obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinion.003","파일 업로드 처리중입니다.");
          obj.showToast(obj.toastInfo);
        });
    },
    outputUpCall() {
      let obj = this;
      obj.$refs.Outputuploadfile.value = ""; // 같은 파일을 연이어 올릴 수 있도록
      if ($("#btn_output_up") != null && $("#btn_output_up").length > 0) {
        $("#btn_output_up")[0].classList.toggle("active");
      }
      obj.$refs.Outputuploadfile.click();
    },
    confirmDeleteAttach(param, _index) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/checkUploadStatus",
        method: "post",
        params: param,
      };

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          let uploadStatus = res.result.uploadStatus;
          if (uploadStatus == "COMPLETE") {
            // ConfirmModal - 파일을 삭제하시겠습니까?
            obj.showConfirmDialog(
              { width: "400px" },
              obj.$i18nUtil.trans("title.dialog.notice","알림"),
              obj.$i18nUtil.trans("AB013"),
              obj.$i18nUtil.trans("button.dialog.delete","삭제"),
              obj.deleteAttach,
              { param: param, index: _index },
              obj.$i18nUtil.trans("button.dialog.cancel","취소"),
              null,
              "deleteAttach"
            );
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinion.003","파일 업로드 처리중입니다.");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
          obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardOpinion.003","파일 업로드 처리중입니다.");
          obj.showToast(obj.toastInfo);
        });
    },
    deleteAttach(_data) {
      let obj = this;
      let param = _data.modalParam.param;
      let _index = _data.modalParam.index;

      if (
        $("#btn_etc_output" + _index) != null &&
        $("#btn_etc_output" + _index).length > 0
      ) {
        $("#btn_etc_output" + _index)[0].classList.toggle("active");
      }
      var paperdelparam = {
        paperId: param.locationId,
        fileId: String(param.fileId),
        regUserId: param.regUserId,
      };
      let reqData = {};
      reqData.url = "/api/cofile/paper/deleteAttach";
      reqData.method = "post";
      reqData.params = {
        groupId: obj.upfile.groupId,
        fileId: String(param.fileId),
        locationKbn: "OUTPUT",
      };

      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let outputdelete = "/api/copaper/output/delete";
        //this.outputdelete();
        obj.outputlistParam();
        obj.toastInfo.message = obj.$i18nUtil.trans("TB011");
        obj.showToast(obj.toastInfo);
        EventBus.$emit("deleteBoardOutputFile", param.fileId);
      });
    },
    deletePaperApiCall(callbackData) {
      let obj = this;
      let param = callbackData.modalParam.param;
      let _index = callbackData.modalParam._index;
      if (
        $("#btn_etc_output" + _index) != null &&
        $("#btn_etc_output" + _index).length > 0
      ) {
        $("#btn_etc_output" + _index)[0].classList.toggle("active");
      }
      var paperdelparam = {
        paperId: param.locationId,
        fileId: String(param.fileId),
        regUserId: param.regUserId,
      };
      let reqData = {};
      reqData.url = "/api/cofile/paper/deleteAttach";
      reqData.method = "post";
      reqData.params = {
        groupId: this.upfile.groupId,
        fileId: String(param.fileId),
        locationKbn: "OUTPUT",
      };

      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        let outputdelete = "/api/copaper/output/delete";
        this.outputdelete(param);
        this.outputlistParam();
        EventBus.$emit("deleteBoardOutputFile", param.fileId);
      });
    },
    outputdelete(param) {
      let obj = this;
      let outputdelete = {
        url: "/api/copaper/output/delete",
        method: "post",
        params: {
          paperId: param.locationId,
          fileId: String(param.fileId),
          regUserId: param.regUserId,
        },
      };
      obj.COWORK_REST_SIMPLE_ACTION(outputdelete);
    },
    outputlistParam() {
      let obj = this;
      let outputdelete = {
        url: "/api/cofile/output/list",
        method: "post",
        params: this.editorData,
      };
      obj.COWORK_REST_SIMPLE_ACTION(outputdelete).then((response) => {
        this.output = response.result;
      });
    },
    deldeci(param, _index) {
      if (confirm(this.$i18nUtil.trans("AG055"))) {
        if (
          $("#btn_etc_deci" + _index) != null &&
          $("#btn_etc_deci" + _index).length > 0
        ) {
          $("#btn_etc_deci" + _index)[0].classList.toggle("active");
        }
        let obj = this;
        let outputdelete = {
          url: "/api/copaper/decision/deldeci",
          method: "post",
          params: param,
        };
        obj.COWORK_REST_SIMPLE_ACTION(outputdelete).then((response) => {
          // obj.items = response.result;
          obj.items = obj.setLocaleData(response.result);
        });
      }
    },
    outputBoard() {
      const modalInfo = {
        name: "OutputBoard",
        obj: this.$modal,
        component: OutputBoard,
        width: "800px",
        //height: "862px",
        item: {
          groupId: this.upfile.groupId,
          paperId: this.upfile.paperId,
        },
      };
      this.showModal(modalInfo);
      if ($("#btn_output_up") != null && $("#btn_output_up").length > 0) {
        $("#btn_output_up")[0].classList.toggle("active");
      }
    },
    leftBtnToggle() {
      // console.log("leftBtnToggle");
      document
        .getElementById("leftBtnToggle")
        .parentElement.classList.toggle("active");
      document.getElementById("boardHeader").classList.toggle("width");
      document.getElementById("boardTab").classList.toggle("width");
    },
    // 드래그앤드랍 파일 업로드
    outputDragDropFile(e, type) {
      let obj = this;
      let dropZone = obj.$el.querySelector(".board-left .output");
      let outputDropZone = obj.$el.querySelector(".board-left .outputDropZone");

      if (
        e.dataTransfer &&
        e.dataTransfer.types &&
        e.dataTransfer.types[0] === "Files"
      ) {
        e.preventDefault();
        e.stopPropagation();

        if (type === "drop" && e.dataTransfer.files) {
          outputDropZone.classList.remove("dropdown-file");
          // Chrome 에서 업로드된 최종결과물이 있는 상태에서 드래그앤드랍 파일 업로드가 안되는 현상 수정 (dropFileActionC 클래스 추가)
          if (e.target.classList.contains("dropFileAction") || e.target.classList.contains("dropFileActionC")) {
            let uploadFileList = e.dataTransfer.files;
            let uploadFileCount = uploadFileList.length;
            let idx = 0;
            let errorCount = 0;

            obj.uploadDragFile(
              uploadFileList,
              idx,
              uploadFileCount,
              errorCount
            );
          }
        } else if (type === "leave") {
          let leaveHandle = dropZone.getAttribute("leave-handle");
          if (leaveHandle) {
            clearTimeout(leaveHandle);
          }
          leaveHandle = setTimeout(function () {
            outputDropZone.classList.remove("dropdown-file");
          }, 100);
          dropZone.setAttribute("leave-handle", leaveHandle);
        } else if (type === "over") {
          let leaveHandle = dropZone.getAttribute("leave-handle");
          if (leaveHandle) {
            clearTimeout(leaveHandle);
          }
          outputDropZone.classList.add("dropdown-file");
        }
      }
    },
    multiElipsis(ellipsisLine) {
      if (this.ellipsisTimer) {
        clearTimeout(this.ellipsisTimer);
      }

      this.ellipsisTimer = setTimeout(function () {
        if ($(".multi-ellipsis").length > 0) {
          var omle = $(".multi-ellipsis");
          var $txtR = $("<div class='txtEllipsis'></div>");
          var $body = $("body");
          omle.each(function (idx) {
            var _this = $(this);
            var orinalWidth = $(this).width();
            var txtOmle = _this.text();

            $txtR.text(txtOmle);
            $body.append($txtR);
            if ($txtR.width() >= orinalWidth * 1.2) {
              _this.addClass("no-ellipsis");
            } else {
              _this.removeClass("no-ellipsis");
            }
          });
        }
      }, 250);

      setTimeout(function () {
        $(".txtEllipsis").remove();
      }, 1000);
      // const obj = this;
      // $(window).on("load resize", function () {
      //   obj.multiElipsis(2);
      // });
    },
    uploadDragFile(uploadFileList, idx, uploadFileCount, errorCount) {
      let obj = this;

      if (idx < uploadFileCount) {
        let uploadFile = uploadFileList[idx];

        obj.upfile.files = [];
        obj.upfile.files.push(uploadFile);
        obj.data.frm = new FormData();
        obj.data.sendType = "post";
        obj.data.url = "/api/cofile/paper/uploadOutput";
        obj.data.header = {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("Authorization"),
        };

        obj.data.frm.append("file", obj.upfile.files[0]);
        obj.data.frm.append("groupId", obj.upfile.groupId);
        obj.data.frm.append("paperId", obj.upfile.paperId);
        obj.data.frm.append("projectId", obj.projectId);
        obj.data.frm.append(
          "sharepointSiteId",
          String(obj.paperInfo.sharepointSiteId)
        );
        obj.data.frm.append(
          "sharepointFolderId",
          String(obj.paperInfo.sharepointFolderId)
        );

        idx++;
        obj.$axios
          .post(obj.data.url, obj.data.frm, obj.data.header)
          .then((response) => {
            let errorCode = response.data.errorCode;
            if (errorCode != null) {
              // 파일 업로드 에러 발생
              if (uploadFileCount > 1) {
                // 업로드 파일이 2개 이상이며 외부망 파일 업로드 불가 에러 코드일 경우 다음 파일 업로드 요청하지 않음
                if (errorCode === "COFILE_FILE_UPLOAD_DENIED_FROM_EXTERNAL") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB100"));
                  return;
                }

                // 외부망 파일 업로드 불가 에러 코드가 아닌 경우 다음 파일 업로드 요청
                errorCount++;
                obj.uploadDragFile(
                  uploadFileList,
                  idx,
                  uploadFileCount,
                  errorCount
                ); // 재귀호출
              } else {
                // 업로드 파일이 1개일 경우 에러메시지 출력
                if (errorCode === "COFILE_DLP_ERROR") {
                  // 2023-06-20 검출 건수 표시 및 공통 함수로 처리
                  //obj.showAlertDialog(obj.$i18nUtil.trans("AB076"));
                  obj.boardUtil.makeDLPErrorMsg(obj, response.data.errorMessage);
                  return;
                } else if (errorCode === "COFILE_STORAGE_CAPACITY_EXCEEDED") {
                  obj.showAlertDialog(
                    obj.$i18nUtil.trans("AB054", { groupKbn: response.data.errorMessage })
                  );
                  return;
                } else if (errorCode === "COFILE_FILE_UPLOAD_DENIED") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB069"));
                  return;
                } else if (errorCode === "COFILE_FILE_UPLOAD_CAPACITY_EXCEEDED") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB108",{ limitSize: response.data.errorMessage /1024 /1024 }));
                  return;
                } else if (errorCode === "COFILE_FILE_UPLOAD_FAIL") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB070"));
                  return;
                }  else if (errorCode === "COFILE_FILE_UPLOAD_DENIED_FROM_EXTERNAL") {
                  obj.showAlertDialog(obj.$i18nUtil.trans("AB100"));
                  return;
                }
              }
            } else {
              // 파일 업로드 성공
              obj.initOutputList();

              if (uploadFileCount > 1) {
                obj.uploadDragFile(
                  uploadFileList,
                  idx,
                  uploadFileCount,
                  errorCount
                ); // 재귀호출
              }
            }
          })
          .catch(function (err) {
            if (uploadFileCount > 1) {
              errorCount++;
              obj.uploadDragFile(
                uploadFileList,
                idx,
                uploadFileCount,
                errorCount
              ); // 재귀호출
            } else {
              obj.showAlertDialog(obj.$i18nUtil.trans("AB070"));
              return;
            }
          });
      } else {
        if (uploadFileCount > 1 && errorCount > 0) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB071"));
        }

        setTimeout(function () {
          EventBus.$emit("uploadBoardOutputFile", "");
        }, 2000);
      }
    },
    timeForToday(value) {
      const today = new Date();
      const timeValue = new Date(value);

      const betweenTime = Math.floor(
        (today.getTime() - timeValue.getTime()) / 1000 / 60 / 60
      );
      if (betweenTime < 24) {
        return this.$i18nUtil.trans("message.BoardOpinion.005","{time} 시간 전", {time: betweenTime});
      } else {
        return this.$moment(value).format("YYYY.MM.DD");
      }
    },
    setLocaleData(items) {
      items.forEach(item => {
        if(this.$i18nUtil.getLanguage() === 'ko') {
          // locale에 따른 사용자명 영문 처리
        }else{
          item.regUserName = item.regUserNameEn != null ? item.regUserNameEn : item.regUserName;
          item.userName = item.userNameEn != null ? item.userNameEn : item.userName;
        }
      })
      return items
    }
  },
};
</script>

<style lang="css" scoped>
.board-left .left_wrap > div > .tit > .btn_add {
  position: absolute;
  right: 0;
  top: -4px;
}

.board-left .left_wrap > div > .tit {
  position: relative;
}
.board-left .left_wrap > div > .tit > .btn_add button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-image: url("../../../../../assets/img/sp_common.svg");
  background-repeat: no-repeat;
  background-position: -98px -38px;
  background-size: 500px auto;
}
.board-left .left_wrap > div > .tit > .btn_add button:hover {
  background-color: #d3d4d6;
}
.hidden {
  display: none !important;
}
.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  min-height: 23px;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}

.enCss.left-btn_toggle::before {
  height: 19px !important;
}

.toggle-approval.active::after {content: ' ';}
.toggle-back::after {
    content: ' ';
    color: #666;
}
.toggle-approval::after {
    content: ' ';
    color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/opinion/BoardOpinion.vue